module.exports = __webpack_public_path__ + "static/media/9DESA5.c19a45ef.jpg";